// extracted by mini-css-extract-plugin
export default {"empty_list_container":"EmptyList_empty_list_container__BJpUr","text":"EmptyList_text__UJX2s"};